import React, {forwardRef, useImperativeHandle, useRef} from 'react';
import PropTypes from 'prop-types';
import {Button, Descriptions} from 'antd';
import classNames from 'classnames';

import {EditOutlined} from '@/icons';
import LocalApiMiniFormModal from './LocalApiMiniFormModal';
import {SecurityTextView} from '@/component';

import styles from '../styles.module.less';

const LocalApiMiniView = forwardRef(({clientAppId, link, reload}, ref) => {
    const LocalApiMiniFormModalRef = useRef();
    console.log('LocalApiMiniFormModalRef', LocalApiMiniFormModalRef);

    const {jsonData} = link;
    const {secret, descript} = JSON.parse(jsonData) || {};
    const labelStyle = {width: 100, fontWeight: 'bold'};

    function showEditModal() {
        LocalApiMiniFormModalRef.current.showModal();
    }

    useImperativeHandle(ref, () => ({
        showEditModal,
    }));

    return (
        <>
            <Descriptions
                column={1}
                title={
                    <span>
                        小程序配置
                        <Button icon={<EditOutlined />} type="link" onClick={showEditModal} />
                    </span>
                }
                className={classNames(styles.meta, styles.apiInfo)}
                style={{marginBottom: 24}}
            >
                <Descriptions.Item label="小程序标题" labelStyle={labelStyle}>
                    {descript || '未定义'}
                </Descriptions.Item>
                <Descriptions.Item label="Secret" labelStyle={labelStyle}>
                    {secret ? <SecurityTextView text={secret} /> : '未定义'}
                </Descriptions.Item>
            </Descriptions>

            <LocalApiMiniFormModal
                ref={LocalApiMiniFormModalRef}
                clientAppId={clientAppId}
                link={link}
                reload={reload}
            />
        </>
    );
});

LocalApiMiniView.displayName = 'LocalApiMiniView';

LocalApiMiniView.propTypes = {
    clientAppId: PropTypes.string.isRequired,
    link: PropTypes.shape({
        jsonData: PropTypes.string,
    }).isRequired,
    reload: PropTypes.func.isRequired,
};

export default LocalApiMiniView;
